import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_AUTH_LIST_REQUEST: '', // post
  GET_AUTH_LIST_SUCCESS: '',
  GET_AUTH_LIST_FAILURE: '',

  GET_AUTH_LIST_GROUP_REQUEST: '', // post
  GET_AUTH_LIST_GROUP_SUCCESS: '',
  GET_AUTH_LIST_GROUP_FAILURE: '',
};

types = setStoreTypeValues(types, 'authList');

export default types;
